export default __webpack_public_path__ + "static/profile-b3ef6aea34ea65d74364e17f91c6fb8a.jpg";